import classNames from "classnames";
import React, { ReactNode, useContext } from "react";
import { VisibilityContext } from "react-horizontal-scrolling-menu";

import { ICarouselItem } from "./Carousel";

interface ICarouselItemProps extends ICarouselItem {
  className: string;
  children: ReactNode;
}

export function CarouselItem({
  itemId,
  className,
  children,
}: ICarouselItemProps) {
  const visibility = useContext(VisibilityContext);

  const visible = visibility.isItemVisible(String(itemId));

  return (
    <div
      className={classNames(className, {
        "in-shadow": !visible,
      })}
    >
      {children}
    </div>
  );
}
